
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/s3",
      function () {
        return require("private-next-pages/destinations/s3.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/s3"])
      });
    }
  